import { t } from "@/i18n-js/instance";
import { Block } from "./Block";
import { BlockContent } from "./BlockContent";
import { BlockStep } from "./BlockStep";
import { Divisor } from "./Divisor";

export const EmptyState = () => (
  <div className="flex size-full flex-col items-center justify-center gap-y-3">
    <Block>
      <BlockStep
        title={
          t(
            "settings.paywalls.modal.tabs.upsell.canvas.empty_state.checkout",
          )[0]
        }
      />
      <BlockContent
        index={1}
        title={
          t(
            "settings.paywalls.modal.tabs.upsell.canvas.empty_state.checkout",
          )[1]
        }
      />
    </Block>
    <Divisor />
    <Block className="shadow-xl">
      <BlockStep
        title={
          t(
            "settings.paywalls.modal.tabs.upsell.canvas.empty_state.post_purchase",
          )[0]
        }
      />
      <BlockContent
        index={2}
        title={
          t(
            "settings.paywalls.modal.tabs.upsell.canvas.empty_state.post_purchase",
          )[1]
        }
      />
    </Block>
    <Divisor />
    <Block>
      <BlockStep
        title={
          t(
            "settings.paywalls.modal.tabs.upsell.canvas.empty_state.post_upsell",
          )[0]
        }
      />
      <BlockContent
        index={3}
        title={
          t(
            "settings.paywalls.modal.tabs.upsell.canvas.empty_state.post_upsell",
          )[1]
        }
      />
    </Block>
  </div>
);
